var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yandex-map',{attrs:{"coords":[53.2282985712013, 34.31553600000001],"zoom":"8","cluster-options":{
  1: {clusterDisableClickZoom: false,
  clusterBalloonContentBodyLayout: 'cluster#balloonAccordionContent'
  }
  },"controls":_vm.controls,"placemarks":_vm.placemarks,"behaviors":['drag', 'dblClickZoom', 'rightMouseButtonMagnifier', 'multiTouch'],"map-type":"map","scroll-zoom":false},on:{"map-was-initialized":_vm.initHandler}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e37f3cce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyMap.vue
// module id = null
// module chunks = 